export default __webpack_public_path__ + "static/hotjar-favicon-4b4a173933d38de12398349ca52d6514.svg";